import type { MealPlanResultsAction, MealPlanResultsState } from './types'
import { MealPlanResultsActionTypes } from './types'

export const initialMealPlanResultsState: MealPlanResultsState = {
  mealPlanResults: [],
  loading: true,
  error: null
}

export function mealPlanResultsReducer(state: MealPlanResultsState, action: MealPlanResultsAction): MealPlanResultsState {
  switch (action.type) {
    case MealPlanResultsActionTypes.SET:
      return {
        ...state,
        mealPlanResults: action.payload,
        loading: false,
        error: null
      }
    case MealPlanResultsActionTypes.SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case MealPlanResultsActionTypes.CLEAR:
      return { ...initialMealPlanResultsState }
    default:
      return state
  }
}
